export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-Heavy.a6d0a7c7.ttf";